import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { Title } from "app/pages/sneakpeek/StyledComponents";

export const DunningsModalLeftImage = styled.img`
    height: 220px;
    width: 220px;
`;

export const DunningsModalLeft = styled(Flex)`
    gap: 8px;
    flex-direction: column;
    width: 519px;
    height: 428px;
    padding: 24px 0;
    border-radius: 8px;
    background: ${colorsPalettes.sky[100]};
    justify-content: center;
    align-items: center;
`;

export const DunningsModalRight = styled(Flex)`
    flex-direction: column;
    justify-content: space-between;
    width: 335px;
    margin: 24px 20px 16px 24px;
`;

export const StyledTitle = styled(Title)`
    padding: 20px 24px;
    margin: 0;
`;

export const DunningsModalContent = styled(Stack)`
    padding: 16px 24px 24px 24px;
    gap: 16px;

    img {
        width: 200px;
        height: 200px;
        margin: 0 auto;
    }
`;

export const DunningsModalFooter = styled(Flex)`
    padding: 8px 16px 16px 16px;
    justify-content: right;
    gap: 16px;
`;

export const DunningsTextContactUsButton = styled.button`
    display: contents;
`;
